import React from 'react';
import Footer from './Footer';
import './First.css'
import './App.css';
import First from './First';
import Body from './Body';
import Resume from './Resume';
import Education from './Education'
import CoverLetter from './CoverLetter'
import {BrowserRouter as Router, Switch,Route} from "react-router-dom";
import Interest from './Interest';
import About from './About'
function App() {
  return (
    <Router>

    <div className="App">
    <Switch>
    <Route path="/coverLetter">
      <First/>
      <CoverLetter/>
    </Route>
    <Route path="/Education">
      <First/>
      <Education/>
    </Route>
    <Route path="/Resume">
      <First/>
            <Resume/>
    </Route>
    <Route path="/About">
      <First/>
            <About/>
    </Route>
    <Route path="/Interest">
      <First/>
            <Interest/>
    </Route>
      <header className="App-header">

<div>
<Route path="/">
        <First/>
    </Route>
  </div>

  <div>
          <Body/>
    </div>
    <div>
            <Footer/>
      </div>
      </header>
        </Switch>
    </div>
    </Router>
  );
}

export default App;
